/**
 * Intentionally has no static imports. Vite/Rollup otherwise runs CSS + react-dom + next-themes
 * before any async boot runs, so a slow vendor chunk never reaches the App import timeout and
 * you only see “Still loading…” at 55s with no actionable error.
 */
export async function launch(): Promise<void> {
  window.__mszBootPhase = "launch:import(bootstrap-app)";
  const { mountApp } = await import("./bootstrap-app");
  window.__mszBootPhase = "launch:mountApp()";
  await mountApp();
}
